import PoolPublish from './create_publish'
import { connect } from 'react-redux'
import { createRemotely } from 'redux/modules/campaign'
import {
  campaignUrlForDisplay,
  campaignUrlWithMeDomain,
} from 'lib/campaign_url'
import {
  getCampaignSelector,
  getLastCreatedCampaignSelector,
} from 'redux/selectors/campaign'
import preventNavigation from 'components/common/prevent_navigation'

const mapStateToProps = (state, props) => {
  const lastCreatedCampaign = getLastCreatedCampaignSelector(state)
  const campaign = lastCreatedCampaign || getCampaignSelector(state, props)

  return {
    campaignId: campaign.id,
    operatingRemotely: campaign.operatingRemotely,
    shareUrl: campaignUrlWithMeDomain(campaign.id),
    displayUrl: campaignUrlForDisplay(campaign.id),
    creationError: campaign.err,
  }
}

const mapDispatchToProps = (dispatch, { campaignId }) => {
  return {
    onPublish() {
      dispatch(createRemotely(campaignId))
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(preventNavigation(PoolPublish, props => props.operatingRemotely))
